// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__e9bKo","hide":"Loader_hide__c-COF","spinner":"Loader_spinner__jDp8a","rotate":"Loader_rotate__Dn0IW"};